import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./CookieConsent.css";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent) {
      // Show after 10 seconds for better UX
      const timer = setTimeout(() => setIsVisible(true), 10000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const text = {
    title: "استفاده از کوکی‌ها",
    message: "ما از کوکی‌ها برای بهبود تجربه شما و تحلیل ترافیک وب‌سایت استفاده می‌کنیم.",
    accept: "قبول",
    decline: "رد",
    learnMore: "اطلاعات بیشتر",
    privacyLink: "حریم خصوصی",
    cookieLink: "سیاست کوکی"
  };

  return (
    <div className="cookie-consent rtl" dir="rtl">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <span className="cookie-icon">🍪</span>
          <span className="cookie-message">
            {text.message}{" "}
            <Link to="/privacy">{text.privacyLink}</Link>{" "}
            و{" "}
            <Link to="/cookies">{text.cookieLink}</Link>
          </span>
        </div>
        <div className="cookie-consent-actions">
          <button onClick={handleDecline} className="cookie-decline-button">
            {text.decline}
          </button>
          <button onClick={handleAccept} className="cookie-accept-button">
            {text.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;

